import { Box, Icon } from "@mui/material";
import { useTranslation } from "react-i18next";

import CopyResultLine from "~/components/CopyResultLine";
import { CaptionText } from "~/components/Typographies";
import { type TenantEmailDomainDnsRecord } from "~/gql/graphqlBase.generated";

interface DomainDnsRecordsTableProps {
	records: readonly TenantEmailDomainDnsRecord[];
}

const DomainDnsRecordsTable = ({ records }: DomainDnsRecordsTableProps) => {
	const { t } = useTranslation("common");

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
			{records.map((record) => (
				<Box key={`${record.type}-${record.host}`}>
					<Box sx={{ alignItems: "center", display: "flex", gap: 0.5, mb: 0.5 }}>
						<CaptionText color="text.secondary">
							{record.type} · {record.host}
						</CaptionText>
						<Icon
							aria-label={t(
								record.valid ? "admin.email.senderSetup.dnsRecordFound" : "admin.email.senderSetup.dnsRecordWaiting"
							)}
							aria-hidden={false}
							role="img"
							sx={{ color: record.valid ? "success.main" : "warning.main", fontSize: "1rem" }}
						>
							{record.valid ? "check_circle" : "schedule"}
						</Icon>
					</Box>
					<CopyResultLine text={record.data} />
				</Box>
			))}
		</Box>
	);
};

export default DomainDnsRecordsTable;
